// =============================================================================
//  Copyright : 2022 semantics GmbH
//  Date      : $Date: 2026-05-25 21:18:10 +0200 (Mon, 25 May 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 163265 $
//  Purpose   : parts for presenation nodes
// =============================================================================
// ---Third-party imports
import React from 'react';
// ---Framework imports
import log from 'uix/logging';
import { loadLazy } from 'uix/parts';
// ---Local imports
// ---Globals
export const PresentationEditor = loadLazy(()=>import(/* webpackChunkName: 'presentation' */ './editor'));
export const PresentationViewer = loadLazy(()=>import(/* webpackChunkName: 'presentation' */ './viewer'));
